/* eslint-disable no-unused-vars */
export enum EHttpMethods {
  DELETE = "DELETE",
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
}

export enum ECONTRACT_STATUS {
  PARTIAL_CONFIRMED_DELIVERY = "PARTIAL_CONFIRMED_DELIVERY",
  BROKER_CREATE_CONTRACT = "BROKER_CREATE_CONTRACT",
  BROKER_CREATED = "BROKER_CREATED",
  SUBMITTED = "SUBMITTED",
  CREATED = "CREATED",
  PENDING_PAID = "PENDING_PAID",
  ADDING_PARTY = "ADDING_PARTY",
  IN_PROGRESS = "IN_PROGRESS",
  WAITING_FOR_SETTLEMENT_CLOSE = "WAITING_FOR_SETTLEMENT_CLOSE",
  WAITING_FOR_SETTLEMENT_RESOLVE = "WAITING_FOR_SETTLEMENT_RESOLVE",
  SETTLED_FOR_CLOSE = "SETTLED_FOR_CLOSE",
  SETTLED_FOR_RESOLVE = "SETTLED_FOR_RESOLVE",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PARTIALLY_RELEASED = "PARTIALLY_RELEASED",
  WAITING_FOR_DELIVERY = "WAITING_FOR_DELIVERY",
  ITEM_INSPECTION = "ITEM_INSPECTION",
  CONTRACT_ACCEPTED = "CONTRACT_ACCEPTED",
  COMPLETED = "COMPLETED",
  CLOSED_REFUND_CUSTOMER = "CLOSED_REFUND_CUSTOMER",
  CLOSED_RELEASE_PROVIDER = "CLOSED_RELEASE_PROVIDER",
  DELIVERY_ESCALATION = "DELIVERY_ESCALATION",
  INSPECTION_ESCALATION = "INSPECTION_ESCALATION",
  PAID = "PAID",
  WAITING_FOR_SHIPMENT = "WAITING_FOR_SHIPMENT",
  ITEM_ACCEPTED = "ITEM_ACCEPTED",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  RESOLVED_REFUND_CUSTOMER = "RESOLVED_REFUND_CUSTOMER",
  RESOLVED_RELEASE_PROVIDER = "RESOLVED_RELEASE_PROVIDER",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  CONTRACT_REJECTED = "CONTRACT_REJECTED",
  CONTRACT_ESCALATED = "Contract_Escalated", //TODO to be updated or removed when backend confirm
  CANCELED = "CANCELED",
  DELETED = "DELETED",
  DELIVERY_ACCEPTED = "DELIVERY_ACCEPTED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  PENDING_PAYMENT_VERIFICATION = "PENDING_PAYMENT_VERIFICATION",
}

export enum EPARTY_STATUS {
  PAID = "PAID",
  INVITED = "INVITED",
  REFUNDED = "REFUNDED",
  ESCALATED = "ESCALATED",
  ARBITRATOR_REFUNDED_CUSTOMER = "ARBITRATOR_REFUNDED_CUSTOMER",
  ARBITRATOR_ACCEPT_ITEM = "ARBITRATOR_ACCEPT_ITEM",
  WAITING_FOR_PAYMENT = "WAITING_FOR_PAYMENT",
  PAYMENT_PENDING_APPROVAL = "PAYMENT_PENDING_APPROVAL",
  WAITING_FOR_ITEM_ACCEPTANCE = "WAITING_FOR_ITEM_ACCEPTANCE",
  ITEM_ACCEPTED = "ITEM_ACCEPTED",
  WAITING_FOR_RELEASE = "WAITING_FOR_RELEASE",
  RELEASED = "RELEASED",
  WAITING_FOR_DELIVERY = "WAITING_FOR_DELIVERY",
}

export enum SENDER_ROLE {
  PROVIDER = "PROVIDER",
  CUSTOMER = "CUSTOMER",
}

export enum USER_ROLE {
  SELLER = "SELLER",
  BUYER = "BUYER",
  BROKER = "BROKER",
}
export enum ETokenType {
  FCM = "FCM",
}
export enum CURRENCY {
  SAR = "ريال",
}

export const ALERTMESSAGE = {
  SUCCESS: "lbl_alert_message_success",
  ERROR: "lbl_alert_message_error",
};
